import PropTypes from "prop-types";
import getCoreNonPrimaryFulfilmentStrings from "../getCoreNonPrimaryFulfilmentStrings";

const CoreNonPrimaryFulfilmentStringsMarkup = ({ labelledById, source }) => {
  const { source_info_label, sourceDescription } =
    getCoreNonPrimaryFulfilmentStrings({ source });

  return (
    <span id={labelledById} aria-hidden={true}>
      {source_info_label} <strong>{sourceDescription}</strong>
    </span>
  );
};

CoreNonPrimaryFulfilmentStringsMarkup.propTypes = {
  labelledById: PropTypes.string.isRequired,
  source: PropTypes.shape({
    id: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
  })
};

export default CoreNonPrimaryFulfilmentStringsMarkup;
